<span
  class="badge mw-100"
  *ngIf="value !== null && value !== undefined"
  [ngClass]="[size, value >= 0 ? 'ca-badge-positive' : 'ca-badge-negative', rootCssClass]"
  [title]="formattedValue"
>
  <span class="text-truncate">
    {{ formattedValue }}
  </span>
</span>
